// @ts-ignore
import jwtDecode from 'jwt-decode';

import apiService from 'services/api.service';
import { loginConcierge, renewAuthConcierge } from 'services/api/concierge.api.service';

const MAX_MILLISECONDS = 2147483647;

class Auth {
  private AUTH_TOKEN: string | null;

  private AUTH_TIMEOUT: number | undefined;

  private AUTH_LOGOUT_EVENT: Event;

  constructor(token: string | null) {
    this.AUTH_TOKEN = token;
    this.AUTH_TIMEOUT = undefined;
    this.AUTH_LOGOUT_EVENT = new Event('auth-logout');
  }

  isAuthed() {
    return !!this.AUTH_TOKEN;
  }

  getAuthToken() {
    return this.AUTH_TOKEN;
  }

  setAuthToken(token: string | null) {
    this.AUTH_TOKEN = token;
  }

  setAuthHeader() {
    apiService.defaults.headers.common.Authorization = this.AUTH_TOKEN;
  }

  // initiate countdown timer to re-authenticate user
  startAuthExpiryCountdown() {
    try {
      clearTimeout(this.AUTH_TIMEOUT);
      const decodedToken = jwtDecode(this.AUTH_TOKEN);
      const minuteInMilliSeconds = 1000 * 60;
      // assumes token expiration value is in seconds
      // set to 1 minute less than token expiration or default to 15 mins
      const authRenewalTimer = decodedToken
        ? decodedToken.exp * 1000 - Date.now() - minuteInMilliSeconds
        : minuteInMilliSeconds * 15;

      this.AUTH_TIMEOUT = window.setTimeout(
        this.renewAuth,
        Math.min(authRenewalTimer, MAX_MILLISECONDS)
      );
    } catch (error) {
      // pass
    }
  }

  login = async (authProviderToken: string) => {
    const responseData = await loginConcierge(authProviderToken);

    if (responseData.token) {
      this.setAuthToken(responseData.token);
      this.setAuthHeader();
      this.startAuthExpiryCountdown();
    }
  };

  logout() {
    this.setAuthToken(null);
    this.setAuthHeader();
    clearTimeout(this.AUTH_TIMEOUT);
    window.dispatchEvent(this.AUTH_LOGOUT_EVENT);
    // to support logging out (ending user session) from different tabs/windows
    window.localStorage.setItem('logout', Date.now().toLocaleString());
    // to support clearing distribution timestamp
    window.localStorage.removeItem('newDistributionReceivedAt');
  }

  renewAuth = async () => {
    const responseData = await renewAuthConcierge();

    if (responseData.token) {
      this.setAuthToken(responseData.token);
      this.setAuthHeader();
      this.startAuthExpiryCountdown();
    }
  };
}

const auth = new Auth(null);
export default auth;
